import React, { useState } from "react";
import RevueSticker1List from '../../Merch-Data/Memegor/memegor-ganci.json'
import DropDownList from  '../../Data/DropDownList'

export default function MemegorGanci() {
    const [nameString, setNameString, emailString, setEmailString, interestString, setInterestString] = useState();
    return (
        <>
        {RevueSticker1List.map((meme) => (
            <div className="w-full h-full min-h-screen py-32">
                <div>
                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-10">
                        <div className="w-full h-full rounded-3xl ">
                            <img src ={meme.img} className="w-full h-full object-scale-down rounded-3xl hover:scale-110 duration-500" alt="" />
                        </div>
                        <div className="w-full h-full px-5 ">
                            <div className="text-base font-mono"><i>{meme.series}</i></div>
                            <div className="text-6xl font-mono py-5">{meme.title}</div>
                            <div className="text-2xl font-mono py-5"><span className="my-5 py-3 px-3 rounded-full bg-[#ffdad4] text-[#930006]">{meme.prices}</span></div>
                            {/* Form */}
                            <div className="my-10 rounded-lg bg-rose-50 pb-10">
                                <form action="https://app.us8.list-manage.com/subscribe/post?u=8c8ef00601d776e3b98c88572&amp;id=313ec75014" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" class="validate" target="_blank" novalidate>
                                    <div className="rounded-t-lg bg-red-100 py-5 px-5">
                                        <h3 className="text-2xl leading-6 font-mono text-gray-900">I am Interested</h3>
                                        <p className="mt-1 text-base font-mono text-gray-500">
                                            This information will be displayed publicly so be careful what you share.
                                        </p>
                                    </div>
                                    
                                    <div className="w-full h-full px-5">

                                        <div className="w-full py-2">
                                            <div className="py-2 font-mono text-base">
                                                <label 
                                                    for="mce-FNAME" 
                                                    className="">Name</label>
                                            </div>
                                            <div className="w-full">
                                                <input 
                                                type="text" 
                                                value={nameString}
                                                onChange={(e) => setNameString(e.target.value)}
                                                name="FNAME"
                                                id="mce-FNAME"
                                                autoComplete="given-name" 
                                                className="w-full border rounded-lg h-10 px-4" />
                                            </div>
                                        </div>

                                        <div className="w-full py-2">
                                            <div className="py-2 font-mono text-base">
                                                <label 
                                                    for="mce-EMAIL" 
                                                    className="">Email Address <span>*</span></label>
                                            </div>
                                            <div className="w-full">
                                                <input 
                                                type="email" 
                                                value={emailString}
                                                onChange={(e) => setEmailString(e.target.value)}
                                                name="EMAIL"
                                                id="mce-EMAIL" 
                                                autoComplete="email"
                                                className="w-full border rounded-lg h-10 px-4" />
                                            </div>
                                        </div>

                                        <div className="w-full py-2">
                                            <div className="py-2 font-mono text-base">
                                                <label 
                                                    for="mce-INTEREST" 
                                                    className="">Interested In <span>*</span></label>
                                            </div>
                                            <div className="w-full">
                                                <select 
                                                    onChange={(e) => setInterestString(e.target.value)}
                                                    name="INTEREST"
                                                    id="mce-INTEREST"
                                                    value={interestString}
                                                    className="w-full border rounded-lg h-10 px-4">
                                                        {/* Page Related Option */}
                                                        <option value={meme.title}>{meme.title}</option>
                                                        {/* Generated List */}
                                                        {DropDownList.map((list) => (
                                                        <>
                                                        <option value={list.value}>{list.name}</option>
                                                        </>
                                                        ))}
                                                </select>
                                            </div>
                                        </div>

                                        {/* real people should not fill this in and expect good things - do not remove this or risk form bot signups--> */} 
                                        <div hidden="true" className="hidden"><input type="hidden" name="tags" value="4791611" /></div>
                                        <div id="mce-responses" className=" hidden clear foot">
                                            <div class="response" id="mce-error-response" className="hidden"></div>
                                            <div class="response" id="mce-success-response" className="hidden"></div>
                                        </div>
                                        <div className="hidden" aria-hidden="true"><input type="text" name="b_8c8ef00601d776e3b98c88572_313ec75014" tabindex="-1" value="" /></div>
                                        <div className="optionalParent">
                                            <div className="clear foot">
                                                <input type="submit" value="I am Interested" name="subscribe" id="mc-embedded-subscribe" className="px-2 py-2 bg-rose-600 text-white font-mono text-base rounded-lg my-4" />
                                                <p className="brandingLogo">
                                                    <a href="http://eepurl.com/h1xoKv" title="Mailchimp - email marketing made easy and fun"><img src="https://eep.io/mc-cdn-images/template_images/branding_logo_text_dark_dtp.svg" alt=""/></a>
                                                </p>
                                            </div>
                                        </div>
                                    </div>  
                                </form>
                            </div>

                            <div>
                                <div className="text-xl font-mono mt-8 py-3"><strong>Description</strong></div>
                                <div className="text-md font-mono py-6">{meme.desc}</div>
                            </div>
                        </div>
                    </div>
                    <div className="w-full h-full mt-32">
                        <div className="font-mono text-3xl my-5"><strong>Preview</strong></div>
                        <img src ={meme.preview1} alt="" className="w-full h-full object-cover rounded-3xl hover:scale-95 duration-500" />
                    
                        <div className="w-full h-full grid lg:grid-cols-2 grid-cols-1 gap-10 my-10">
                            <div className="w-full h-full rounded-3xl">
                                <img src={meme.preview2} alt="" className="w-full h-full object-cover rounded-3xl hover:scale-95 duration-500" />
                            </div>
                            <div className="w-full h-full rounded-3xl">
                                <img src={meme.preview3} alt="" className="w-full h-full object-cover rounded-3xl hover:scale-95 duration-500" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ))}
        </>
    )
};

